import { Customer } from "../../CRUDs/entities/Customer";
import { Job } from "../../CRUDs/entities/Job";
import { SectionSwitcher } from "../SectionSwitcher";
import { Visit } from "../../CRUDs/entities/Visit";
import { checkActionAttribute } from "./checkActionAttribute";
import { Section } from "../Section";

export const jobsModalActionsListners = (target, actionsWindow, parents=null) => {

    checkActionAttribute([
        { attribute: 'data-customer-active',     className: 'job-action' },
        { attribute: 'data-customer-active',     className: 'return-to-request' },
        { attribute: 'data-customer-active',     className: 'edit-job' },
        { attribute: 'data-customer-active',     className: 'create-invoice' },
        { attribute: 'data-customer-active',     className: 'create-visit' },
        { attribute: 'data-customer-active',     className: 'attachments' },
        { attribute: ['data-customer-active', 'data-has-invoices'], className: 'view-invoices' },
        { attribute: 'data-customer-active',     className: 'contact' },
    ], target, actionsWindow, parents);

    actionsWindow.find('.action').off();

    const jobId = target.parent().attr('data-id');
    const customerId = target.parent().attr('data-customer-id');
    const requestId = target.parent().attr('data-request-id');

    const customer = new Customer(customerId);
    const staticVisit = new Visit();

    const job = new Job(jobId);

    // contact customer
    actionsWindow.find('.action.contact').on('click', (e) => {
        customer.openModal('contact', {id: customerId});
    });

    // return to request
    actionsWindow.find('.action.return-to-request').on('click', (e) => {
        job.returnToRequest();
    });

    // schedule a visit visit
    actionsWindow.find('.action.create-visit').on('click', (e) => {
        staticVisit.openModal('create', { job_request_id: requestId });
    });

    // view job invoices
    actionsWindow.find('.action.select').on('click', function() {
        const entityClass = $(this).attr('class').split(' ').pop().split('-').pop();
        const sectionSwitcher = new SectionSwitcher();
        const section = SectionSwitcher.getSectionByTitle(entityClass)
        let jobData = job.read()
        $(`.filter.${entityClass} select[name=status]`).val(0)
        $(`.filter.${entityClass} input[name=job_request_id]`).val(jobData?.job_request_id)
        sectionSwitcher.showSelectedSection(entityClass)
        if(section instanceof Section){
            section.filter.main({status:0,job_request_id:jobData?.job_request_id})
        }
    });

    // create invoice
    actionsWindow.find('.action.create-invoice').on('click', (e) => {
        window.open(`/jobs-flow/invoice/create?job_request_id=${requestId}`, '_blank');
    });

    // view logs
    actionsWindow.find('.action.view-logs').on('click', (e) => {
        job.openModal('logs');
    });

    // edit job - not complete!!!
    actionsWindow.find('.action.edit-job').on('click', (e) => {
        job.openModal('edit');
    });

    // view details - not complete!!!
    actionsWindow.find('.action.details').on('click', (e) => {
        job.openModal('view');
    });

    // view attachments
    actionsWindow.find('.action.attachments').on('click', (e) => {
        $('.modal-window-actions').hide();
        job.viewAttachments();
    });
}
